import { render } from "./LivePlayersModal.vue?vue&type=template&id=8723dc00&scoped=true"
import script from "./LivePlayersModal.vue?vue&type=script&lang=js"
export * from "./LivePlayersModal.vue?vue&type=script&lang=js"

import "./LivePlayersModal.vue?vue&type=style&index=0&id=8723dc00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8723dc00"]])

export default __exports__